import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-by-example/react-by-example/packages/gatsby/src/layouts/default.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "final-words"
    }}>{`Final Words`}<a parentName="h1" {...{
        "href": "#final-words",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h1>
    <ul>
      <li parentName="ul">{`well done for making it this far`}</li>
    </ul>
    <h2 {...{
      "id": "what-next"
    }}>{`What next?`}<a parentName="h2" {...{
        "href": "#what-next",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h2>
    <ul>
      <li parentName="ul">{`build stuff`}<ul parentName="li">
          <li parentName="ul">{`todo app`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://eugenkiss.github.io/7guis/",
              "target": "_blank",
              "rel": "noreferrer"
            }}>{`7guis`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://hnpwa.com/",
              "target": "_blank",
              "rel": "noreferrer"
            }}>{`hacker news progressive web app`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://reactjs.org/community/examples.html",
              "target": "_blank",
              "rel": "noreferrer"
            }}>{`project ideas from React`}</a></li>
        </ul></li>
    </ul>
    <h2 {...{
      "id": "get-in-touch"
    }}>{`Get in touch`}<a parentName="h2" {...{
        "href": "#get-in-touch",
        "aria-hidden": true,
        "tabIndex": -1,
        "className": "slug"
      }}>{`#`}</a></h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/reactbyexample/react-by-example",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`star this on GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/reactbyexample/react-by-example/issues",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`found a bug? have a better example? suggestions for new topics?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://monzo.me/barnabasforgo/3",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`buy me a beer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "mailto:react-by-example@outlook.com",
          "target": "_blank",
          "rel": "noreferrer"
        }}>{`ask a question? hire me?`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      